<template>
  <screen-locker>
    <template v-slot:content>
      <div
        class="page page-home d-flex flex-column align-items-start flex-fill"
      >
        <AppHeader :hide-steps="true" :show-menu="true"></AppHeader>
        <div class="row header-page w-100">
          <div class="col">
            <h3 class="text-center">
              GeneraSviluppo Sostenibile
            </h3>
            <div class="row h-100">
              <div class="col h-100">
                <div class="main-sub-title text-center">
                  Le tue scelte di oggi possono contribuire a creare un mondo
                  migliore
                </div>
                <div class="banner banner-home d-flex align-items-center">
                  <div class="w-100">
                    <svg-viewer
                      :src="
                        window.width <= 1440
                          ? require('../assets/images/banner/00-main.svg')
                          : require('../assets/images/banner/00-wide.svg')
                      "
                      :height="window.width <= 1440 ? '350px' : '430px'"
                      width="100%"
                    ></svg-viewer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex footer-page w-100">
          <div class="credits">
            <span>
              <div class="credit-title">
                Mio<span>S</span> | Mio Impatto <SPAN>Sostenibile</SPAN>
              </div>
              &copy; Generali Italia S.p.A - C.F. 00409920584 - P.IVA
              00885351007
            </span>
          </div>
          <b-button variant="white w-auto ml-auto mr-3" @click="showModal()">
            Scopri il prodotto
          </b-button>
          <b-button variant="primary" @click="startSimulation()"
            >Inizia percorso</b-button
          >
        </div>
      </div>
      <b-modal
        v-model="modal"
        adaptive="true"
        title="GSS"
        dialog-class="modal-full"
        hide-footer
      >
        <template v-slot:modal-header>
          &nbsp;
          <b-button
            variant="link modal-close"
            size="sm"
            class="float-right"
            @click="modal = false"
          >
            <img src="../assets/images/close.svg" alt="Chiudi" />
          </b-button>
        </template>
        <b-container style="height: 80vh">
          <genera-sviluppo-sostenibile />
        </b-container>
      </b-modal>
      <auth-guard />
    </template>
  </screen-locker>
</template>

<script>
import router from "../router";
import GeneraSviluppoSostenibile from "./modals/GeneraSviluppoSostenibile";
export default {
  name: "Home",
  components: { GeneraSviluppoSostenibile },
  data: () => {
    return {
      modal: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    startSimulation() {
      router.push("/user-data");
    },
    showModal() {
      this.modal = true;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>

<style scoped></style>
